var map = {
	"./BOU/virtual_kit.png": "705d",
	"./DRU/virtual_kit.png": "0b28",
	"./FNB/virtual_kit.png": "c690",
	"./HIM/virtual_kit.png": "ccca",
	"./OTH/virtual_kit.png": "5d18",
	"./SUP/virtual_kit.png": "5e78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec1a";